"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FormattedHTMLMessage", {
  enumerable: true,
  get: function get() {
    return _formattedMessage["default"];
  }
});
Object.defineProperty(exports, "FormattedMessage", {
  enumerable: true,
  get: function get() {
    return _formattedMessage["default"];
  }
});
Object.defineProperty(exports, "IntlProvider", {
  enumerable: true,
  get: function get() {
    return _intlProvider["default"];
  }
});
var _intlProvider = _interopRequireDefault(require("./intl-provider.js"));
var _formattedMessage = _interopRequireDefault(require("./formatted-message.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }